import styled from '@emotion/styled'
import { font, colors, spacing } from '../Theme/Common'
import { gapY } from '../Utils/gap'
import { greaterThan, lessOrEqualThan } from '../Utils/media'

const smallScreen = lessOrEqualThan('px375')
const largeScreen = greaterThan('px375')

export const RadioGroup = styled.div(
  {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: spacing.bigx3,
  },
  gapY(spacing.smx1)
)

export const BlackbookAlertPromptStyled = styled.div({
  fontFamily: font.family.primary,
  display: 'grid',
  height: '100%',
  gridTemplateColumns: '1fr',
  gridTemplateRows: 'min-content min-content min-content 1fr',
  gap: '1rem',

  header: {
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    fontWeight: font.weight.semibold,
    [smallScreen]: {
      ...font.size.xl,
    },
    [largeScreen]: {
      ...font.size.xl6,
    },
  },

  'div.description': {
    display: 'flex',
    flexDirection: 'row',
    color: colors.neutral[800],
    fontWeight: font.weight.regular,
    [smallScreen]: {
      ...font.size.md,
    },
    [largeScreen]: {
      padding: '0 2rem',
      ...font.size.lg,
    },
  },

  'div.description-icon': {
    [smallScreen]: {
      display: 'none',
    },
    [largeScreen]: {
      paddingRight: '1rem',
    },
  },

  'div.description-title': {
    fontWeight: font.weight.semibold,
    color: colors.neutral[900],
    paddingBottom: '1.5rem',
  },

  'div.selection-methods': {
    display: 'flex',
    flexDirection: 'column',
    margin: '1.5rem',
  },

  'div.selection-methods-title': {
    fontWeight: font.weight.bold,
    paddingBottom: '1.5rem',
    ...font.size.xl,
  },

  footer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '0 3.5rem',
  },
})
